let userGestureActive = false;

export function markUserGestureStart() {
  userGestureActive = true;
}

export function consumeUserGesture() {
  return userGestureActive;
}

// 🔹 new helper
export function resetUserGesture() {
  userGestureActive = false;
}
